<template>
<!-- <v-card hover @click="$emit('click')" class="mx-auto" rounded outlined> -->
	<v-list-item two-line outlined elevation='5' @click="$emit('click')" v-slot:default="{ active }">
		<v-list-item-avatar>
			<v-icon v-if="active" color="secondary">mdi-folder-open</v-icon>
			<v-icon v-else color="primary">mdi-folder</v-icon>
		</v-list-item-avatar>
		<v-list-item-content>
			<v-list-item-title v-text="title" />
		</v-list-item-content>
	</v-list-item>
<!-- </v-card> -->
</template>

<script>
export default {
	name: 'CollectionItem',
	props: {
		title: String,
		isOpen: Boolean,
	},
}
</script>